import { render } from "./MarketAds.vue?vue&type=template&id=38ef1178"
import script from "./MarketAds.vue?vue&type=script&lang=js"
export * from "./MarketAds.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__